import React, { useState } from "react";
import TelegramChat from "./TelegramChat";
import TelegramChatWindowAdmin from "./TelegramChatWindowAdmin";

const TelegramModal = ({role, user, userId, socket, isSocketConnected}) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);  

  return (
    <div>
      <button
        onClick={openModal}
        className="fixed top-4 right-4 p-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
      >
        {role === 'admin' ? 'Panel ADMIN' : 'Conectar con ADMIN'}
      </button>

      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-1/2 shadow-xl dark:shadow-gray-900/50">
            {role === 'admin' ? (
              <TelegramChatWindowAdmin user={user} userId={userId} role={role} socket={socket} isSocketConnected={isSocketConnected} />
            ) : (
              <TelegramChat user={user} userId={userId} socket={socket} isSocketConnected={isSocketConnected}/>
            )}
            
            <div className="flex justify-end space-x-4">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors dark:bg-red-600 dark:hover:bg-red-700"
              >
                Cerrar
              </button>              
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TelegramModal;